import {
  debounce
} from '../utils';

export class Toggler {
  constructor() {
    this._elem = document.querySelector('.toggler');
    this._text = this._elem.querySelector('.toggler__text');
    this._counter = this._elem.querySelector('.toggler__circle');
    this._callback = null;

    this._elemClickHandler = this._elemClickHandler.bind(this);

    this._elem.addEventListener('click', this._elemClickHandler);
  }

  setClickHandler(callback) {
    this._callback = callback;
  }

  hide() {
    this._elem.classList.add('toggler--hide');
  }

  update(count) {
    if (count !== 0) {
      this._counter.classList.add('active');
    } else {
      this._counter.classList.remove('active');
    }
    this._counter.textContent = count;
  }

  _elemClickHandler() {
    this._callback();
  }
}
